import { z } from "zod";

import { parseUrlState } from "components/notice_lists/useNoticeListsPageState";
import { useURLState } from "lib/hooks/useURLState";
import { EMPTY_FILTERS, NoticeColumnsSchema, NoticeFilters } from "./utils";

export function useFilterableNoticeTableState(defaultFilters: NoticeFilters = EMPTY_FILTERS) {
  const [noticeTableFilters, setNoticeTableFilters] = useURLState<NoticeFilters | undefined>(
    "noticeFilters",
    defaultFilters,
    (val) => parseUrlState(val as NoticeFilters, defaultFilters, null),
    { encoder: "compress" },
  );

  const [noticeTableColumns, setNoticeTableColumns] = useURLState(
    "noticeColumns",
    undefined,
    z.array(NoticeColumnsSchema).optional(),
  );

  return {
    noticeTableFilters,
    setNoticeTableFilters,
    noticeTableColumns,
    setNoticeTableColumns,
    tableColumns: noticeTableColumns,
  };
}
